interface MagnifyingGlassThinIconProps {
  className?: string;
  color?: string;
}

const MagnifyingGlassThinIcon = ({
  className = "w-6 h-6",
  color = "#000000",
}: MagnifyingGlassThinIconProps) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2685 20.7339L16.3278 15.7933C17.7126 14.2701 18.4466 12.2656 18.3731 10.2084C18.2996 8.15113 17.4244 6.20421 15.9346 4.78364C14.4447 3.36307 12.4583 2.58153 10.3999 2.60603C8.34149 2.63053 6.37428 3.45912 4.91866 4.91475C3.46303 6.37038 2.63443 8.33759 2.60993 10.396C2.58543 12.4544 3.36697 14.4408 4.78754 15.9307C6.20811 17.4205 8.15504 18.2957 10.2123 18.3692C12.2696 18.4427 14.274 17.7086 15.7972 16.3239L20.7378 21.2646C20.8082 21.3349 20.9036 21.3745 21.0032 21.3745C21.1027 21.3745 21.1981 21.3349 21.2685 21.2646C21.3388 21.1942 21.3784 21.0988 21.3784 20.9993C21.3784 20.8997 21.3388 20.8043 21.2685 20.7339ZM3.37815 10.4992C3.37815 9.09006 3.79603 7.71251 4.57893 6.54081C5.36184 5.36911 6.47461 4.45588 7.77654 3.91661C9.07846 3.37733 10.5111 3.23623 11.8932 3.51115C13.2753 3.78607 14.5448 4.46466 15.5413 5.46111C16.5377 6.45756 17.2163 7.72711 17.4913 9.10923C17.7662 10.4913 17.6251 11.9239 17.0858 13.2259C16.5465 14.5278 15.6333 15.6406 14.4616 16.4235C13.2899 17.2064 11.9123 17.6242 10.5032 17.6242C8.6141 17.6223 6.80298 16.871 5.46721 15.5352C4.13144 14.1994 3.38014 12.3883 3.37815 10.4992Z"
        fill={color}
      />
    </svg>
  );
};

export default MagnifyingGlassThinIcon;